// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"6c788aba","576":"bab3fbc7","614":"4a13ff9c","629":"8ff6349a","777":"df2ad693","791":"6e2b8981","840":"68d56f8a","992":"740929e4"}[chunkId] + ".chunk.js";
};